import { useTranslation } from 'react-i18next';
import styles from './EmptyGoalDetails.module.css';
import supportIcon from '@/assets/icons/supportGoals/support.svg';

const EmptyGoalDetails = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.icon}>
          <img src={supportIcon} alt="support"/>
        </div>
        <div className={styles.text}>
          <p className={styles.subtitle}>{t('viewSupportGoalDetails')}</p>
          <div className={styles.title}>{t('chooseSupportGoal')}</div>
        </div>
      </div>
    </div>
  );
};

export default EmptyGoalDetails;


